import i18next from 'i18next'

import { SelectOption } from 'components/Select'
import { DomainBidderPriority } from 'features/globalSetup/types/bidderPriority'
import {
  TargetingActionType,
  targetingActionTypes,
} from 'features/inventory/domain/types/targetingActionType'

export const targetingActionTypeOptions: SelectOption<TargetingActionType>[] =
  targetingActionTypes.map(
    (actionType: TargetingActionType): SelectOption<TargetingActionType> => ({
      label: i18next.t(
        `features/domain:form.general.advancedSettings.targetingActionType.values.${actionType}`,
      ),
      value: actionType,
    }),
  )

export const domainBidderPriorityOptions = (
  priorities: DomainBidderPriority[],
): SelectOption<DomainBidderPriority>[] =>
  priorities.map(
    (priority: DomainBidderPriority): SelectOption<DomainBidderPriority> => ({
      label: i18next.t(`features/globalSetup:prebid.bidders.priorityOptions.${priority}`),
      value: priority,
    }),
  )
